// Used in view-assignment, composite-tasks, resource.component, activity-preview-dialog, tile-resources, tiles.component, global-resources, resource-container,
// page-header, composite-assignment-submit

import { CookieService } from "#core/services";
import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { eBookActivity, eReader } from "@carnegie-learning/cure-types";
import {
    CompositeTaskAssignment,
    GradeAttempt,
    Teacher,
    PPUser as User,
} from "cli-types";

@Injectable()
export class GetBookshelfUrlHelper {
    userID?: number;
    isTeacher = false;
    isStudent = false;
    urlPath = "";
    beiUserID?: number;
    authMethod = "";
    accessToken = "";
    API_ROOT = (<any>window).apiHost;
    BOOKSHELF_HOST_URL = (<any>window).bookshelfHostURL;
    BOOKSHELF_API_CALLBACK_URL = (<any>window).bookshelfAPICallbackURL;
    assignmentID = "";

    constructor(
        private domSanitizer: DomSanitizer,
        private cookieService: CookieService
    ) {}

    private setProfileVars(profile: User) {
        this.beiUserID = profile.beiUserID;
        this.userID = profile.userID;
        this.isStudent = profile.roleLevel === 5;
        this.isTeacher = profile.roleLevel === 4;
        this.accessToken = this.cookieService.get("CL_TOKEN2");

        // set the base url based on beiUserID
        if (this.beiUserID) {
            this.urlPath = this.BOOKSHELF_HOST_URL + "/ws/emcl/gotobook?";
            this.authMethod = "&user_id=" + this.beiUserID;
        } else {
            // If the BEI userID is not present in the cookie we will redirect via API
            this.urlPath = this.API_ROOT + "/api/assignments/redirectToBei?";
            this.authMethod = "&access_token=" + this.accessToken;
        }
    }

    // get the Bookshelf URL for a specific Discover activity
    public activity(
        asset: eBookActivity | eReader,
        profile: User,
        courseID: number | null,
        assignmentID: number | string | null
    ) {
        const beiBookID = asset.bookId || asset.externalId;
        const page = (<eBookActivity>asset).page;
        const interactionID = (<eBookActivity>asset).interactionId;

        this.setProfileVars(profile);

        if (this.isTeacher) {
            // Teacher
            return (
                this.urlPath +
                "book_id=" +
                beiBookID +
                "&practice=true" +
                "&state=" +
                (<Teacher>profile).state +
                (interactionID ? "&activity=" + interactionID : "") +
                (page ? "&rel_page=" + page : "") +
                this.authMethod
            );
        } else {
            // Student
            return (
                this.urlPath +
                "book_id=" +
                beiBookID +
                this.authMethod +
                (page ? "&rel_page=" + page : "") +
                "&course_id=" +
                courseID +
                (interactionID ? "&activity=" + interactionID : "") +
                (assignmentID ? "&assignment_id=" + assignmentID : "") +
                this.BOOKSHELF_API_CALLBACK_URL
            );
        }
    }

    // get the Bookshelf URL for an ebook
    public book(
        bookId: string | number,
        courseID: number,
        profile: User,
        practice: number | undefined | null,
        inQA = 0
    ) {
        this.setProfileVars(profile);
        if (this.isTeacher) {
            // Teacher
            let link: string = this.urlPath + "book_id=" + bookId;

            //
            if (practice === 1) {
                // normal case, when not included activites are disabled in book
                link = link + "&practice=true";
            }

            link =
                link +
                "&course_id=" +
                courseID +
                "&state=" +
                (<Teacher>profile).state +
                this.authMethod +
                this.BOOKSHELF_API_CALLBACK_URL;

            return link;
        } else {
            let p = "";
            if (practice === 1) {
                p = "&practice=true";
            }
            return (
                this.urlPath +
                "book_id=" +
                bookId +
                p +
                "&course_id=" +
                courseID +
                this.authMethod +
                this.BOOKSHELF_API_CALLBACK_URL
            );
        }
    }

    // get the spine activity attempt url
    public getAttemptLink(attemptObj: GradeAttempt | CompositeTaskAssignment) {
        const attemptURL = `${this.BOOKSHELF_HOST_URL}/activityservice/activity-portal?attempt_id=${attemptObj.attemptID}`;
        return this.domSanitizer.bypassSecurityTrustResourceUrl(attemptURL);
    }
}
